import { Grid, Typography, Box, makeStyles, } from '@material-ui/core';
import React, { useContext, useState } from 'react';
import CountyContext from '../../contexts/CountyContext';
import FiltersContext from '../../contexts/FiltersContext';
import StoryContext from '../../contexts/StoryContext';
import SubquestionBox from '../SubquestionBox';
import CountyComparisonTableNSH from './CountyComparisonTableNSH';
import CountyMapNSH from './CountyMapNSH';
import PercentByQualityRating from './PercentByQualityRating';
import PercentBySettingType from './PercentBySettingType';
import ErrorBoundary from '../ErrorBoundary';

function Q3Row3() {
  const [familyType, setFamilyType] = useState('All');
  const [settingType, setSettingType] = useState('All');
  const [childAge, setChildAge] = useState('All');

  const [county, setCounty] = useState(null);
  const [countyCode, setCountyCode] = useState(null);

  const { lightColor, darkColor } = useContext(StoryContext);

  const classes = makeStyles((theme) => ({
    title: {
      color: `${darkColor} !important`,
      textTransform: 'capitalize',
    }
  }))();

  return (
    <FiltersContext.Provider value={{
      familyType, setFamilyType, settingType, setSettingType, childAge, setChildAge,
    }}
    >
      <CountyContext.Provider value={{
        county, setCounty, countyCode, setCountyCode,
      }}
      >
        <SubquestionBox color={lightColor}>
          <Grid
            spacing={2}
            container
            direction="row"
            justify="center"
            alignItems="flex-start"
          >

            <Grid item xs={6}>
              <Typography variant="h4" component="h3" align="center" className={classes.title} gutterBottom>
                NSH child care by county
              </Typography>
            </Grid>
            {/* <Grid item xs={12}>
              <Filters />
            </Grid> */}
            <Grid item xs={12} sm={8}>
              <Box displayPrint="none">
                <Typography variant="h6" align="center" style={{ textTransform: 'none' }}>
                  To explore access to providers offering NSH care by county, click on one below.
                </Typography>
              </Box>
              <ErrorBoundary>
                <CountyMapNSH />
              </ErrorBoundary>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Grid
                spacing={2}
                container
                direction="row"
                justify="center"
                alignItems="flex-start"
              >
                <Grid item xs={12} align="center">
                  <ErrorBoundary>
                    <PercentBySettingType height={245} />
                  </ErrorBoundary>
                </Grid>
                <Grid item xs={12} align="center">
                  <ErrorBoundary>
                    <PercentByQualityRating height={245} />
                  </ErrorBoundary>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <div className="pagebreak100" />
          <Grid
            spacing={2}
            container
            direction="row"
            justify="center"
            alignItems="flex-start"
          >
            <Grid item xs={12}>
              <ErrorBoundary>
                <CountyComparisonTableNSH />
              </ErrorBoundary>
            </Grid>
          </Grid>

        </SubquestionBox>
      </CountyContext.Provider>
    </FiltersContext.Provider>
  );
}

export default Q3Row3;
